import * as React from "react";
const SvgPubManager = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 46.799, height: 50, viewBox: "0 0 46.799 50", fill: "none", ...props });
export default SvgPubManager;
